module.exports = __webpack_public_path__ + "img/43b3000.png";